<script setup lang="ts">
import { useFeaturesStore } from '@/stores/features/store'
import DialogModal from '@/components/Base/Modal/DialogModal.vue'

const featuresStore = useFeaturesStore()
</script>

<template>
  <DialogModal
    v-if="featuresStore.isHideHelpModalVisible"
    :title="$t('helpTips.hideHelpModal.title')"
    :text="$t('helpTips.hideHelpModal.text')"
    matomo-context="Hide help tips modal"
    @primary-button-click="featuresStore.hideHelpTips()"
    @secondary-button-click="featuresStore.isHideHelpModalVisible = false"
  />
</template>
